import React from "react";
import { PauseIcon, ResumeIcon } from "../constants/icons";

export default function ControlButton({ playClick, paused, setPaused }) {

    const clicked = () => {
        playClick()
        setPaused(!paused)
        
    }

    return (
        <button onClick={() => clicked()} className={paused ? "buttons-control paused" : "buttons-control"} type="button">
            {paused ? <ResumeIcon /> : <PauseIcon /> }
        </button>
    );
}
